// This file is AUTOGENERATED, do not edit it manually!!!

export const commonClient = {
    all_projects_label: 'Alle Projekte',
    archive_action_text: 'Archivieren',
    btn_reload: 'Neu laden',
    Cancel: 'Abbrechen',
    change: 'Ändern',
    Close: 'Schließen',
    completeActivityConfirm: 'Sie haben den Fortschritt dieser Aktivität auf 100 % gesetzt. Möchten Sie die Aktivität abschließen? \'OK\' drücken, um den Status zu ändern, andernfalls „Abbrechen“.',
    completeActivityTitle: 'Möchten Sie diese Aktivität abschließen?',
    completeProjectConfirm: 'Sie haben den Fortschritt dieser Aktivität auf 100 % gesetzt. Möchten Sie dieses Projekt abschließen? \'OK\' drücken, um den Status zu ändern.',
    completeProjectTitle: 'Möchten Sie dieses Projekt abschließen?',
    confirmCompleteActivityParents: 'Nach Abschluss dieser Unteraktivität verbleiben keine offenen Unteraktivitäten für die übergeordnete Aktivität. Möchten Sie die übergeordnete Aktivität als abgeschlossen markieren? Beachten Sie, dass das Projekt ebenfalls als abgeschlossen markiert wird, wenn keine Aktivitäten mehr im Projekt offen sind.',
    confirmCompleteActivityParentsTitle: 'Status für {0} auf \'abgeschlossen\' setzen?',
    continue: 'Weiter',
    DayAbbreviation: 'T',
    DayPluralFormat: '1#Tag#Tage',
    DayPluralFormatTemplate: '1#{0} Tag#{0} Tage',
    Delete: 'Löschen',
    delete_confirmation: 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
    disabledUserText: '(deaktiviert)',
    Duplicate: 'Duplizieren',
    Edit: 'Bearbeiten',
    ElapsedTime_Ago: 'vor {0}',
    Entity_Category: 'Kategorie',
    Entity_Customer: 'Kunde',
    Entity_Issue: 'Ticket',
    Entity_Portfolio: 'Portfolio',
    Entity_Priority: 'Priorität',
    Entity_Project: 'Projekt',
    Entity_ProjectStatus: 'Status',
    Entity_Request: 'Anfrage',
    Entity_Task: 'Aufgabe',
    Entity_TaskStatus: 'Status',
    Entity_User: 'Benutzer',
    Error_CantFindObjectTemplate: 'Vorgang konnte aus folgende(n/m) Grund/Gründen nicht abgeschlossen werden: Begriff (Typ: {entityName}, ID: {objectKey}) nicht in Datenbank gefunden.  Dies könnte aufgrund der Löschung des Begriffs oder unzureichender Zugriffsrechte der Fall sein. Wenden Sie sich bei Rückfragen hierzu bitte an Ihren {brandName}-Administrator.',
    error_notFullyCompleted: 'Das Objekt oder der zugehörige Benutzer wurden gelöscht oder Ihre Zugriffsberechtigungen wurden von einem anderen Benutzer widerrufen.',
    ErrorFileSizeLimit: 'Der Upload der Datei {0} konnte nicht abgeschlossen werden, da Sie keine Dateien größer als ∼ {1} GB hochladen dürfen.',
    ErrorUploadExceededText: 'Der Upload der Datei {0} konnte nicht abgeschlossen werden, da der Speicher für Ihr Konto voll ist.',
    ErrorUploadText: 'Der Upload der Datei {0} wurde aufgrund eines unbekannten Fehlers nicht abgeschlossen. Bitte wiederholen Sie den Upload-Vorgang.',
    ErrorUploadTitle: 'Fehler beim Upload der Datei.',
    failed: 'Fehlgeschlagen',
    help: 'Hilfe',
    HourAbbreviation: 'Std',
    HourPluralFormat: '1#Stunde#Stunden',
    HourPluralFormatTemplate: '1#{0} Stunde#{0} Stunden',
    HyperLinkTooltip: 'Klicken Sie bei gedrückter STRG-Taste, um dem Link zu folgen',
    MinuteAbbreviation: 'Min',
    MinutePluralFormat: '1#{0} Minute#{0} Minuten',
    next: 'Weiter',
    None_Text: 'Keine',
    Not_set: 'Nicht gesetzt',
    Ok: 'OK',
    OpeningWindow: 'Wird geöffnet...',
    OperationError_Title: 'Vorgang konnte nicht abgeschlossen werden',
    parentActivity: 'Übergeordnete Aktivität',
    Remove: 'Entfernen',
    Reset: 'Zurücksetzen',
    Save: 'Speichern',
    saved: 'Gespeichert',
    saving: 'Wird gespeichert',
    Search: 'Suchen',
    setCompleted: 'Als abgeschlossen markieren',
    summary: 'Zusammenfassung',
    timer_text: '1#{0} Sekunde#{0} Sekunden',
    title_notFullyCompleted: 'Der Vorgang konnte nicht teilweise oder vollständig abgeschlossen werden',
    title_reload: 'Bitte laden Sie die Seite neu',
    total: 'Gesamt',
    type: 'Angeben',
    Type_for_search: 'Zum Suchen eingeben',
    Type_for_search_or_add: 'Zum Suchen oder Hinzufügen eingeben',
    upload: 'Hochladen',
    WebPushNotificationPanelLink: 'Desktop-Benachrichtigungen zu aktivieren.',
    WebPushNotificationPanelText: '{brandName} braucht Ihre Erlaubnis, um ',
    you_user_text: 'sie',
};
